exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".v5t06TRsOeMUDMQnYoyPM {\n  cursor: pointer;\n  pointer-events: all;\n  color: #FFF; }\n\n.Q1Suh1PnogvUjYp5fDcg9 {\n  cursor: not-allowed;\n  pointer-events: none;\n  color: #FFF;\n  opacity: .8; }\n\n._1M8QRzyDMWTYCenJKZ4c5t {\n  display: none;\n  visibility: hidden; }\n\n.uJYQ0qTl7XvHLKoiCSy4e {\n  display: block;\n  width: 30px;\n  height: 30px;\n  color: #FFF; }\n\n._2GflfmqwaYB2qLzX2ey8p8 {\n  position: relative; }\n\n._16fXrOcWTt7zR7RfJV-cDc {\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  padding-bottom: 15px; }\n  ._16fXrOcWTt7zR7RfJV-cDc._3g6zNZaiv9EzypziOuhuoH {\n    display: none; }\n\n._2de5BsC_TROol822hJDj2c {\n  padding: 16px 18px;\n  background-color: rgba(0, 0, 0, 0.8);\n  border-radius: 5px; }\n\n.urVWpavSqihMZbXG2J7sk {\n  position: relative;\n  height: 100px;\n  width: 3px;\n  background-color: #FFF; }\n\n._2Xy-XF0I43HeNHwPvSg2qI {\n  position: relative;\n  height: 100%;\n  background-color: #19c3dd;\n  transform-origin: bottom center;\n  pointer-events: none; }\n\n._1JBxjTYI2aPUth7YdIJH7r {\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  width: 13px;\n  height: 13px;\n  border-radius: 50%;\n  background-color: #FFF;\n  transform: translate(-50%, 50%);\n  pointer-events: none; }\n", ""]);

// exports
exports.locals = {
	"uiElementActive": "v5t06TRsOeMUDMQnYoyPM",
	"uiElementInactive": "Q1Suh1PnogvUjYp5fDcg9",
	"uiElementHidden": "_1M8QRzyDMWTYCenJKZ4c5t",
	"svg": "uJYQ0qTl7XvHLKoiCSy4e",
	"volume": "_2GflfmqwaYB2qLzX2ey8p8",
	"container": "_16fXrOcWTt7zR7RfJV-cDc",
	"isClosed": "_3g6zNZaiv9EzypziOuhuoH",
	"inner": "_2de5BsC_TROol822hJDj2c",
	"volumeBar": "urVWpavSqihMZbXG2J7sk",
	"volumeBarFill": "_2Xy-XF0I43HeNHwPvSg2qI",
	"volumeBarFigure": "_1JBxjTYI2aPUth7YdIJH7r"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/js/standard/VolumeSlider/styles.scss
// module id = 57
// module chunks = 0